import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import Autocomplete from '@mui/material/Autocomplete'
// import { TextField } from 'react-material-ui-form-validator'
import { TextField, Box } from '@mui/material'
import { themeV5 } from 'theme/v5'

const SearchDropdown = ({ id, options = [], disabled, label, value, onChange, showError, allowFreeText, size, hideLabelOnMobile, props }) => {

  const [textFieldValue, setTextFieldValue] = useState('')

  const onSelect = useCallback((_, input) => {
    if (onChange && input) {
      onChange(input.value || input || null)
    } else {
      onChange('')
    }
  }, [onChange])

  const onTextFieldChange = ({ target: { value } }) => {
    setTextFieldValue(value)
    allowFreeText && onChange(value)
  }

  const labelParams = hideLabelOnMobile ? null : { label }

  return (
    <div>
      <Autocomplete
        id={id || 'search_dropdown'}
        size={size}
        freeSolo={!!allowFreeText}
        options={options}
        disabled={disabled}
        onChange={onSelect}
        getOptionLabel={option => option && (option.label || option)}
        value={(options && options.find(item => item.value === value || item === value)) || ''}
        renderInput={params => (
          <TextField
            sx={{
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: showError ? themeV5.palette.error.main : '#C3C3C3',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: showError ? themeV5.palette.error.main : '#767676',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: showError ? themeV5.palette.error.main : '#767676',
              },
            }}
            error={showError}
            {...props}
            {...params}
            {...labelParams}
            fullWidth
            inputProps={{ ...params.inputProps, maxLength: 48 }}
            value={textFieldValue}
            onChange={onTextFieldChange}
            variant="outlined"/>
        )}/>

      {showError && (
        <Box
          component="span"
          sx={{
            marginLeft: '14px',
            marginRight: '14px',
            color: themeV5.palette.error.main,
            margin: 0,
            fontSize: '11px',
            marginTop: '3px',
            textAlign: 'left',
            fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
            fontWeight: 400,
            lineHeight: '13px',
            letterSpacing: '0.33px',
          }}>
          This field is required
        </Box>
      )}
    </div>
  )
}

SearchDropdown.propTypes = {
  id: PropTypes.string,
  size: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  showError: PropTypes.bool,
  allowFreeText: PropTypes.bool,
  hideLabelOnMobile: PropTypes.bool,
}

export default SearchDropdown
